const H = 40;
export {
  H as MONTH_ITEM_HEIGHT
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/date-picker/src/config.js
// module id = 326
// module chunks = 67